module.exports = __webpack_public_path__ + "static/media/im3.a4d82bca.png";